<div class="p-grid">
    <div class="p-col-10 m-auto">
        <div class="p-d-flex p-jc-between p-ai-end">
            <h1 class="p-mr-5 p-ml-5 p-mt-5">{{'GLOBAL.VEHICULO' | translate}}</h1>
        </div>

        <div class="delim p-ml-5 p-mr-5"></div>
        <form class="p-m-5" name="registroVehiculoForm" #registroVehiculoForm="ngForm">
            <div class="p-grid p-mb-2">
                <div class="p-xl-6 p-lg-6 p-md-6 p-sm-12">
                    <label for="matricula">{{'GLOBAL.MATRICULA' | translate}}</label>
                    <input #matricula="ngModel" id="matricula" class="w-100" type="text" pInputText [(ngModel)]="vehiculo.matricula" name="matricula" required [placeholder]="'GLOBAL.MATRICULA' | translate" (input)="validadorMatricula()" />
                    <small *ngIf="(matricula.dirty && matricula.invalid)" class="p-invalid">{{'REGISTRO.MATRICULA.OBLIGATORIO' | translate}}</small>
                    <small *ngIf="(mensajeErrorMatricula) " class="p-invalid">{{'REGISTRO.ERROR.MATRICULA' | translate}}</small>
                </div>
                <div class="p-xl-6 p-lg-6 p-md-6 p-sm-12">
                    <label for="tipoVehiculo">{{'VEHICULO.TIPO' | translate}}</label>
                    <p-dropdown [style]="{'width':'100%'}" [options]="tipoVehiculos" [(ngModel)]="vehiculo.tipoVehiculo" name="tipoVehiculo" [placeholder]="'VEHICULO.TIPO' | translate" optionLabel="nombre"></p-dropdown>
                </div>
            </div>
            <div class="p-grid p-mb-2">
                <div class="p-lg-3">
                    <label for="peso">{{'GLOBAL.PESO' | translate}}</label>
                    <input #peso="ngModel" id="peso" class="w-100" type="number" pInputText [(ngModel)]="vehiculo.peso" name="peso" required [placeholder]="'GLOBAL.PESO' | translate" />
                    <small *ngIf="(peso.invalid && submitted) || (peso.dirty && peso.invalid) " class="p-error" style="color: red;">Peso es obligatorio.</small>
                </div>
                <div class="p-lg-3">
                    <label for="nDisco">{{'VEHICULO.NUMERO.DISCO' | translate}}</label>
                    <input #nDisco="ngModel" id="nDisco" class="w-100" type="number" pInputText [(ngModel)]="vehiculo.nDisco" name="nDisco"  [placeholder]="'VEHICULO.NUMERO.DISCO' | translate" />
                </div>
                <div class="p-xl-6 p-lg-6 p-md-6 p-sm-12">
                    <label for="distintivoAmbiental">{{'VEHICULO.DISTINTIVO.AMBIENTAL' | translate}}
                      <a href="https://sede.dgt.gob.es/es/vehiculos/distintivo-ambiental/" target="_blank">
                        <i class="fas fa-info-circle" pTooltip="Información Distintivo Ambiental" tooltipPosition="top"></i>
                    </a>
                </label>
                    <p-dropdown [style]="{'width':'100%'}" [options]="distintivosAmbientales" [(ngModel)]="vehiculo.distintivoAmbiental" [placeholder]="'VEHICULO.DISTINTIVO.AMBIENTAL' | translate" name="distintivoAmbiental" optionLabel="nombre" (onChange)="validAllData()"></p-dropdown>
                </div>
            </div>
            <div class="p-grid p-mb-2">
                <div class="p-xl-6 p-lg-6 p-md-6 p-sm-12">
                    <label for="clasificacionVehiculo">{{'VEHICULO.CLASIFICACION' |translate}}</label>
                    <p-dropdown [style]="{'width':'100%'}" [options]="clasificacionVehiculos" [(ngModel)]="vehiculo.clasificacionVehiculo" [placeholder]="'VEHICULO.CLASIFICACION' |translate" name="clasificacionVehiculo" optionLabel="descripcion" (onChange)="validAllData()"></p-dropdown>
                </div>
                <div class="p-xl-6 p-lg-6 p-md-6 p-sm-12">
                    <label for="tipoCombustible">{{'VEHICULO.TIPO.COMBUSTIBLE'|translate}}</label>
                    <p-dropdown [style]="{'width':'100%'}" [options]="tiposCombustible" [(ngModel)]="vehiculo.tipoCombustible" [placeholder]="'VEHICULO.TIPO.COMBUSTIBLE'|translate" name="tipoCombustible" optionLabel="nombre" (onChange)="validAllData()"></p-dropdown>
                </div>
            </div>
            <div class="p-grid p-mb-2">
                <div class="p-xl-6 p-lg-6 p-md-6 p-sm-12">
                    <label for="usoVehiculo">{{'VEHICULO.USO' | translate}}</label>
                    <p-dropdown [style]="{'width':'100%'}" [options]="usosVehiculos" [(ngModel)]="vehiculo.usoVehiculo" [placeholder]="'VEHICULO.USO' | translate" name="usoVehiculo" optionLabel="nombre" (onChange)="validAllData()"></p-dropdown>
                </div>
                <div class="p-xl-6 p-lg-6 p-md-6 p-sm-12" *ngIf="vehiculo.usoVehiculo.id === 2">
                    <label for="sector">{{'VEHICULO.SECTOR' | translate}}</label>
                    <p-dropdown [style]="{'width':'100%'}" [options]="sectores" [(ngModel)]="vehiculo.sector" [placeholder]="'VEHICULO.SECTOR' | translate" name="sector" optionLabel="nombre" (onChange)="validAllData()"></p-dropdown>
                </div>
            </div>
            <div class="p-grid p-jc-between p-mb-2">
                <div class="p-col-2">
                    <button class="pr-2 pl-2 pb-1 pt-1" pButton [label]="'GLOBAL.VOLVER' | translate" (click)="volver()"></button>
                </div>
                <div class="p-col-2 p-d-flex p-jc-end">
                    <button class="pr-2 pl-2 pb-1 pt-1" type="submit"
                     [disabled]="registroVehiculoForm.form.invalid || mensajeErrorMatricula || !isAllData"


                     pButton [label]="'GLOBAL.SIGUIENTE' | translate" (click)="siguienteVehiculo()"></button>
                </div>
            </div>
        </form>
        <dum-toast #dumToast></dum-toast>
    </div>
</div>
